import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-group-item list-group-item-action" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "mr-2" }
const _hoisted_5 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.version.author), 1),
        _withDirectives(_createElementVNode("div", {
          title: _ctx.timestampAbsoluteString(),
          class: "mx-2"
        }, _toDisplayString(_ctx.timestampString()), 9, _hoisted_5), [
          [_vShow, _ctx.isRelative()]
        ]),
        _withDirectives(_createElementVNode("div", { class: "mx-2" }, _toDisplayString(_ctx.timestampString()), 513), [
          [_vShow, !_ctx.isRelative()]
        ])
      ]),
      _createElementVNode("button", {
        class: "btn btn-icon-sm btn-revert btn-menu",
        title: "Revert to this version",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.revert()))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass((_ctx.isSpinning ? 'visible fa-spin' : 'd-none') + ' fas faw fa-spinner'),
          role: "status",
          "aria-hidden": "true"
        }, null, 2),
        _createElementVNode("i", {
          class: _normalizeClass((_ctx.isSpinning ? 'd-none' : '') + ' fas fa-undo-alt')
        }, null, 2)
      ])
    ])
  ]))
}